jQuery(function($) {
  var toggleFaq = function(elem) {
    var faqToggle = $(elem);
    var faqItem = $(elem).parent().parent();
    $(faqItem).toggleClass('faq__item--open');

    $(faqToggle).toggleClass('faq__toggle--active');
  }

  $('.faq__toggle').on('click', function(e) {
    e.preventDefault();
    toggleFaq(this);
  })
  $('.faq__heading').on('click', function(e) {
    e.preventDefault();
    toggleFaq($(this).parent().parent().find('.faq__toggle'));
  })
});
